import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=56183e64&scoped=true&"
import script from "./addMenu.vue?vue&type=script&lang=js&"
export * from "./addMenu.vue?vue&type=script&lang=js&"
import style0 from "./addMenu.vue?vue&type=style&index=0&id=56183e64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56183e64",
  null
  
)

export default component.exports